import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { Region } from 'stores/type';

type Props = {
    NZChild: JSX.Element | string | null;
    AUChild: JSX.Element | string;
};

export const RegionWrapper: React.FC<Props> = ({ NZChild, AUChild }) => {
    const accountRegion = useSelector<RootState, Region>(state => state.userInfo.region);
    return <>{accountRegion === Region.NZ ? NZChild : AUChild}</>;
};

export default RegionWrapper;
